<template>
	<div class="page-breed">
		<div class="pageTitleBox">
			<div class="boxNameL">
				饲养计划详情
			</div>
		</div>
		<div class="breeddetail" v-if="breedplanDl">
			<div class="breeditem">顾客：{{breedplanDl.user_info.user_name}}</div>
			<div class="breeditem">手机号：{{breedplanDl.user_info.user_mobile}}</div>
			<div class="breeditem">套餐名称：{{breedplanDl.gift_bag_info.title}}</div>
			<div class="breeditem">计划名称：{{breedplanDl.gift_bag_info.gift_bag_plan.name}}</div>
			<div class="breeditem">状态:
				<span v-if="breedplanDl.status==1">进行中</span>
				<span v-if="breedplanDl.status==2">发货中</span>
				<span v-if="breedplanDl.status==3">已完成</span>
			</div>
		</div>
		<div class="breeddetail" v-if="breedplanDl">
			<div class="breeditem">操作人：{{breedplanDl.plan_list[breedplanDl.plan_list.length-1].delivery_user.user_name}}
			</div>
			<div class="breeditem">
				结束日期：{{$public.FTime(breedplanDl.plan_list[breedplanDl.plan_list.length-1].real_delivery_time,'YYYY-MM-DD')}}
			</div>

		</div>
		<div class="breedgoodslist"  v-if="breedplanDl">
		<el-collapse>
			<el-collapse-item v-for="(item,index) in breedplanDl.plan_list" :key='index'>
				<template slot="title">

					<div style="width: 80%;display: flex;justify-content: space-between;">
						<span>第{{item.plan_num}}次计划</span>
						<span>状态：
							<span v-if="item.plan_status==1">未发货</span>
							<span v-if="item.plan_status==2">已发货</span>
						</span>
						<span>执行日期：{{$public.FTime(item.real_delivery_time,'YYYY-MM-DD')}}</span>
						<span>物流单号：{{item.ship_no}}</span>
						<span>物流名称：{{item.ship_name}}</span>
						<span style="color: #FF4400;" @click="setship(item)">{{item.ship_no?'修改单号':'录入单号'}}</span>
					</div>
				</template>

				<div>
					<el-table ref='table' :data="item.goods_list" style="width: 100%" default-expand-all
						row-class-name="row-expand-cove">
						<el-table-column prop="date" label="类型" width="100">
							<template slot-scope="scope">
								<span v-if="scope.row.goods_type==0">商品</span>
								<span v-else>洗美卡</span>
							</template>
						</el-table-column>
						<el-table-column prop="goods_name" label="名称">
						</el-table-column>
						<el-table-column prop="sku_value" label="规格">
						</el-table-column>
						<el-table-column prop="count" label="数量" width="80">
						</el-table-column>
						<el-table-column type="expand" width="1">
							<template slot-scope="props">
								<div class="goodscustom">
									<div style="margin-top: 10px;" v-if="props.row.order_item_goods_list.length>0">
										<span v-for="(goodscustom,subindex) in props.row.order_item_goods_list"
											:key='subindex'>
											<el-tag @close="handleClose(goodscustom)">
												{{goodscustom.custom_code}}
											</el-tag>
										</span>
									</div>
									<div style="margin: 10px;color: #000;" v-else>
										暂无条码数据
									</div>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>

			</el-collapse-item>

		</el-collapse>

		</div>
<el-dialog title="物流信息" :visible.sync="dialogVisible" width="30%">
			<el-form ref="form" label-width="80px">
				<el-form-item label="物流单号">
					<el-input style="width: 200px;" size='mini' v-model="shipParams.ship_no"></el-input>
				</el-form-item>
				<el-form-item label="物流名称">
					<el-input style="width: 200px;" size='mini' v-model="shipParams.ship_name"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" size='mini' @click="submitShip">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getbreedplanDl,
		getPetGiftDl,
		setPlanShip
	} from '../../../api/program.js'
	export default {
		data() {
			return {
				breedplanDl: '',
				currentGoods: [],
				shipParams: {
					id: '',
					plan_no: '',
					ship_no: '',
					ship_name: '',
				},
				dialogVisible:false,
			}
		},
		methods: {
			getbreedplanDl(id) {
				getbreedplanDl({
					id
				}).then(res => {
					if (res.code == 0) {
						this.breedplanDl = res.data;
						getPetGiftDl({
							id: res.data.gift_bag_info._id
						}).then(response => {
							if (response.code == 0) {
								let card = response.data.gift_bag_plan_items.card.map(item => {
									return {
										...item,
										...{
											goods_type: 0
										}
									}
								})
								let goods = response.data.gift_bag_plan_items.goods.map(item => {
									return {
										...item,
										...{
											goods_type: 6
										}
									}
								})
								this.currentGoods = [...card, ...goods];

							}
						})
					}
				})
			},
			setship(item) {
				this.dialogVisible = true;
				this.shipParams.id = this.breedplanDl._id;
				this.shipParams.plan_no = item.plan_no;
				this.shipParams.ship_no = item.ship_no == null ? '' : item.ship_no;
				this.shipParams.ship_name = item.ship_name == null ? '' : item.ship_name;

			},
			submitShip() {
				setPlanShip(this.shipParams).then(res => {
					if (res.code == 0) {
						this.$message({
							message: '录入成功',
							type: 'success'
						});
						this.dialogVisible = false;
						
						this.getbreedplanDl(this.$route.query.id)
					}
				})
			}

		},
		created() {
			this.getbreedplanDl(this.$route.query.id)
		}
	}
</script>

<style lang="scss" scoped>
	.breeddetail {
		display: flex;
		font-size: 14px;
		// justify-content: space-between;
		background-color: #fff;
		padding: 10px;
		// width: 50%;
		flex-wrap: wrap;

		.breeditem {
			margin-left: 30px;

			&:first-child {
				margin-left: 0;
			}
		}

	}
</style>

